'use client';

import { c as _c } from "react/compiler-runtime";
import { Menu as MenuPrimitive } from '@base-ui/react/menu';
import { cn } from 'cn';
import { CheckIcon, ChevronRightIcon } from 'lucide-react';
type DropdownMenuProps = MenuPrimitive.Root.Props;
export function DropdownMenu(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MenuPrimitive.Root data-slot="dropdown-menu" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type DropdownMenuPortalProps = MenuPrimitive.Portal.Props;
export function DropdownMenuPortal(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MenuPrimitive.Portal data-slot="dropdown-menu-portal" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type DropdownMenuTriggerProps = MenuPrimitive.Trigger.Props;
export function DropdownMenuTrigger(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MenuPrimitive.Trigger data-slot="dropdown-menu-trigger" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type DropdownMenuContentProps = MenuPrimitive.Popup.Props & Pick<MenuPrimitive.Positioner.Props, 'align' | 'alignOffset' | 'side' | 'sideOffset'>;
export function DropdownMenuContent(props) {
  const $ = _c(18);
  let className;
  let rest;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== props) {
    ({
      align: t0,
      alignOffset: t1,
      side: t2,
      sideOffset: t3,
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const align = t0 === undefined ? "start" : t0;
  const alignOffset = t1 === undefined ? 0 : t1;
  const side = t2 === undefined ? "bottom" : t2;
  const sideOffset = t3 === undefined ? 4 : t3;
  let t4;
  if ($[7] !== className) {
    t4 = cn("z-50 max-h-(--available-height) w-(--anchor-width) min-w-48 origin-(--transform-origin) overflow-x-hidden overflow-y-auto rounded-2xl bg-popover p-1 text-popover-foreground shadow-2xl ring-1 ring-foreground/5 duration-100 outline-none", "data-[side=bottom]:slide-in-from-top-2", "data-[side=inline-end]:slide-in-from-left-2", "data-[side=inline-start]:slide-in-from-right-2", "data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2", "data-[side=top]:slide-in-from-bottom-2", "dark:ring-foreground/10", "data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95", "data-closed:animate-out data-closed:overflow-hidden data-closed:fade-out-0 data-closed:zoom-out-95", className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== rest || $[10] !== t4) {
    t5 = <MenuPrimitive.Popup data-slot="dropdown-menu-content" className={t4} {...rest} />;
    $[9] = rest;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== align || $[13] !== alignOffset || $[14] !== side || $[15] !== sideOffset || $[16] !== t5) {
    t6 = <MenuPrimitive.Portal><MenuPrimitive.Positioner className="isolate z-50 outline-none" align={align} alignOffset={alignOffset} side={side} sideOffset={sideOffset}>{t5}</MenuPrimitive.Positioner></MenuPrimitive.Portal>;
    $[12] = align;
    $[13] = alignOffset;
    $[14] = side;
    $[15] = sideOffset;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
type DropdownMenuGroupProps = MenuPrimitive.Group.Props;
export function DropdownMenuGroup(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MenuPrimitive.Group data-slot="dropdown-menu-group" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type DropdownMenuLabelProps = {
  inset?: boolean;
} & MenuPrimitive.GroupLabel.Props;
export function DropdownMenuLabel(props) {
  const $ = _c(10);
  let className;
  let inset;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      inset,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = inset;
    $[3] = rest;
  } else {
    className = $[1];
    inset = $[2];
    rest = $[3];
  }
  let t0;
  if ($[4] !== className) {
    t0 = cn("px-3 py-2.5 text-xs text-muted-foreground data-inset:pl-9.5", className);
    $[4] = className;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== inset || $[7] !== rest || $[8] !== t0) {
    t1 = <MenuPrimitive.GroupLabel data-slot="dropdown-menu-label" data-inset={inset} className={t0} {...rest} />;
    $[6] = inset;
    $[7] = rest;
    $[8] = t0;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}
type DropdownMenuItemProps = {
  inset?: boolean;
  variant?: 'default' | 'destructive';
} & MenuPrimitive.Item.Props;
export function DropdownMenuItem(props) {
  const $ = _c(12);
  let className;
  let inset;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      className,
      inset,
      variant: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = inset;
    $[3] = rest;
    $[4] = t0;
  } else {
    className = $[1];
    inset = $[2];
    rest = $[3];
    t0 = $[4];
  }
  const variant = t0 === undefined ? "default" : t0;
  let t1;
  if ($[5] !== className) {
    t1 = cn("group/dropdown-menu-item relative flex cursor-default items-center gap-2.5 rounded-xl px-3 py-2 text-sm outline-hidden select-none", "focus:bg-accent focus:text-accent-foreground", "not-data-[variant=destructive]:focus:**:text-accent-foreground", "data-inset:pl-9.5", "data-[variant=destructive]:text-destructive", "data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive", "dark:data-[variant=destructive]:focus:bg-destructive/20", "data-disabled:pointer-events-none data-disabled:opacity-50", "[&_svg]:pointer-events-none [&_svg]:shrink-0", "[&_svg:not([class*='size-'])]:size-4", "data-[variant=destructive]:*:[svg]:text-destructive", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== inset || $[8] !== rest || $[9] !== t1 || $[10] !== variant) {
    t2 = <MenuPrimitive.Item data-slot="dropdown-menu-item" data-inset={inset} data-variant={variant} className={t1} {...rest} />;
    $[7] = inset;
    $[8] = rest;
    $[9] = t1;
    $[10] = variant;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
type DropdownMenuSubProps = MenuPrimitive.SubmenuRoot.Props;
export function DropdownMenuSub(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MenuPrimitive.SubmenuRoot data-slot="dropdown-menu-sub" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type DropdownMenuSubTriggerProps = {
  inset?: boolean;
} & MenuPrimitive.SubmenuTrigger.Props;
export function DropdownMenuSubTrigger(props) {
  const $ = _c(13);
  let children;
  let className;
  let inset;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      inset,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = inset;
    $[4] = rest;
  } else {
    children = $[1];
    className = $[2];
    inset = $[3];
    rest = $[4];
  }
  let t0;
  if ($[5] !== className) {
    t0 = cn("flex cursor-default items-center gap-2 rounded-xl px-3 py-2 text-sm outline-hidden select-none", "focus:bg-accent focus:text-accent-foreground", "not-data-[variant=destructive]:focus:**:text-accent-foreground", "data-inset:pl-9.5", "data-popup-open:bg-accent data-popup-open:text-accent-foreground", "data-open:bg-accent data-open:text-accent-foreground", "[&_svg]:pointer-events-none [&_svg]:shrink-0", "[&_svg:not([class*='size-'])]:size-4", className);
    $[5] = className;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ChevronRightIcon className="ml-auto" />;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== inset || $[10] !== rest || $[11] !== t0) {
    t2 = <MenuPrimitive.SubmenuTrigger data-slot="dropdown-menu-sub-trigger" data-inset={inset} className={t0} {...rest}>{children}{t1}</MenuPrimitive.SubmenuTrigger>;
    $[8] = children;
    $[9] = inset;
    $[10] = rest;
    $[11] = t0;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}
type DropdownMenuSubContentProps = React.ComponentProps<typeof DropdownMenuContent>;
export function DropdownMenuSubContent(props) {
  const $ = _c(16);
  let className;
  let rest;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== props) {
    ({
      align: t0,
      alignOffset: t1,
      side: t2,
      sideOffset: t3,
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const align = t0 === undefined ? "start" : t0;
  const alignOffset = t1 === undefined ? -3 : t1;
  const side = t2 === undefined ? "right" : t2;
  const sideOffset = t3 === undefined ? 0 : t3;
  let t4;
  if ($[7] !== className) {
    t4 = cn("w-auto min-w-36 rounded-2xl bg-popover p-1 text-popover-foreground shadow-2xl ring-1 ring-foreground/5 duration-100", "data-[side=bottom]:slide-in-from-top-2", "data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2", "data-[side=top]:slide-in-from-bottom-2", "data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95", "data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className);
    $[7] = className;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== align || $[10] !== alignOffset || $[11] !== rest || $[12] !== side || $[13] !== sideOffset || $[14] !== t4) {
    t5 = <DropdownMenuContent data-slot="dropdown-menu-sub-content" className={t4} align={align} alignOffset={alignOffset} side={side} sideOffset={sideOffset} {...rest} />;
    $[9] = align;
    $[10] = alignOffset;
    $[11] = rest;
    $[12] = side;
    $[13] = sideOffset;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
type DropdownMenuCheckboxItemProps = {
  inset?: boolean;
} & MenuPrimitive.CheckboxItem.Props;
export function DropdownMenuCheckboxItem(props) {
  const $ = _c(15);
  let checked;
  let children;
  let className;
  let inset;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      children,
      checked,
      inset,
      ...rest
    } = props);
    $[0] = props;
    $[1] = checked;
    $[2] = children;
    $[3] = className;
    $[4] = inset;
    $[5] = rest;
  } else {
    checked = $[1];
    children = $[2];
    className = $[3];
    inset = $[4];
    rest = $[5];
  }
  let t0;
  if ($[6] !== className) {
    t0 = cn("relative flex cursor-default items-center gap-2.5 rounded-xl py-2 pr-8 pl-3 text-sm outline-hidden select-none", "focus:bg-accent focus:text-accent-foreground", "focus:**:text-accent-foreground", "data-inset:pl-9.5", "data-disabled:pointer-events-none data-disabled:opacity-50", "[&_svg]:pointer-events-none [&_svg]:shrink-0", "[&_svg:not([class*='size-'])]:size-4", className);
    $[6] = className;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  let t1;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="pointer-events-none absolute right-2 flex items-center justify-center" data-slot="dropdown-menu-checkbox-item-indicator"><MenuPrimitive.CheckboxItemIndicator><CheckIcon /></MenuPrimitive.CheckboxItemIndicator></span>;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== checked || $[10] !== children || $[11] !== inset || $[12] !== rest || $[13] !== t0) {
    t2 = <MenuPrimitive.CheckboxItem data-slot="dropdown-menu-checkbox-item" data-inset={inset} className={t0} checked={checked} {...rest}>{t1}{children}</MenuPrimitive.CheckboxItem>;
    $[9] = checked;
    $[10] = children;
    $[11] = inset;
    $[12] = rest;
    $[13] = t0;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}
type DropdownMenuRadioGroupProps = MenuPrimitive.RadioGroup.Props;
export function DropdownMenuRadioGroup(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MenuPrimitive.RadioGroup data-slot="dropdown-menu-radio-group" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
type DropdownMenuRadioItemProps = {
  inset?: boolean;
} & MenuPrimitive.RadioItem.Props;
export function DropdownMenuRadioItem(props) {
  const $ = _c(13);
  let children;
  let className;
  let inset;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      children,
      inset,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = inset;
    $[4] = rest;
  } else {
    children = $[1];
    className = $[2];
    inset = $[3];
    rest = $[4];
  }
  let t0;
  if ($[5] !== className) {
    t0 = cn("relative flex cursor-default items-center gap-2.5 rounded-xl py-2 pr-8 pl-3 text-sm outline-hidden select-none", "focus:bg-accent focus:text-accent-foreground", "focus:**:text-accent-foreground", "data-inset:pl-9.5", "data-disabled:pointer-events-none data-disabled:opacity-50", "[&_svg]:pointer-events-none [&_svg]:shrink-0", "[&_svg:not([class*='size-'])]:size-4", className);
    $[5] = className;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="pointer-events-none absolute right-2 flex items-center justify-center" data-slot="dropdown-menu-radio-item-indicator"><MenuPrimitive.RadioItemIndicator><CheckIcon /></MenuPrimitive.RadioItemIndicator></span>;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children || $[9] !== inset || $[10] !== rest || $[11] !== t0) {
    t2 = <MenuPrimitive.RadioItem data-slot="dropdown-menu-radio-item" data-inset={inset} className={t0} {...rest}>{t1}{children}</MenuPrimitive.RadioItem>;
    $[8] = children;
    $[9] = inset;
    $[10] = rest;
    $[11] = t0;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}
type DropdownMenuSeparatorProps = MenuPrimitive.Separator.Props;
export function DropdownMenuSeparator(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("-mx-1 my-1 h-px bg-border/50", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <MenuPrimitive.Separator data-slot="dropdown-menu-separator" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
type DropdownMenuShortcutProps = React.ComponentProps<'span'>;
export function DropdownMenuShortcut(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("ml-auto text-xs tracking-widest text-muted-foreground group-focus/dropdown-menu-item:text-accent-foreground", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <span data-slot="dropdown-menu-shortcut" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}